const china_language_list = ["zh-CN", "zh-cn"];
const browser_language = window.navigator.language;
export default china_language_list.includes(browser_language);